import React, { useContext, useMemo, useRef } from 'react'
import { MessageSwitchProps } from '../MessageSwitch'
import { MessageWrapper } from './MessageWrapper'
import classNames from 'classnames'
import { useNarrow } from '~/utils/useNarrow'
import { MessageRedirect } from '~/service/chatConn/types'
import { UsersManagerContext } from '~/service/UsersManager'

export type TextAnswerProps = MessageSwitchProps<MessageRedirect>

const Redirect: React.FC<TextAnswerProps> = ({ ...props }) => {
  const { get } = useContext(UsersManagerContext)
  const { message } = props

  const userFrom = useMemo(() => get(message.userFrom)!, [])
  const userTo = useMemo(() => get(message.userTo)!, [])

  const ref = useRef<HTMLDivElement>(null)

  useNarrow(ref, props.parentWidth)

  return (
    <>
      <MessageWrapper
        {...props}
        className={classNames('is-redirect')}
        _ref={ref}
      >
        <div>
          <div>
            <img src={userFrom.avatar} />
            <strong>{userFrom.name}</strong>
          </div>

          {intl.formatMessage({ id: 'chat / output / redirect' })}

          <div>
            <img src={userTo.avatar} />
            <strong>{userTo.name}</strong>
          </div>
        </div>
      </MessageWrapper>
    </>
  )
}

export default Redirect
